import React, { Component } from 'react';
import Wrapper from './../../../../common/component/Wrapper';
import {
    getTitleTable, formatMoney, columnsTable,
    getDataSource, genaratePaginateFilterSort,
    getPermissionActions
} from '../../../../../../helpers/functions';
import { parseListRequestParams } from '../../../../../../utils/commonUtils';

import SaleReport from '../../../../../../models/SaleReport';
import DEFINE, { DATE_TIME_FORMAT, ORDER, CASH_FLOW_REPORT } from '../../../../../../constants/Define';
import * as HMS from "../../../../common/component/Index";
import EllipsisText from '../../../../common/component/EllipsisText';
import {Tooltip, Icon} from 'antd';
import moment from 'moment';
import './ReportList.less';

let permisionActions = [];
const defaultState = {

};

const ReportListCols = ['identity', 'orderCode', 'productCode', 'ticketCode', 'rateCode', 'ticketSerial', 'checkCode', 'transactionCode', 'transactionName', 'action',
'postDate', 'orderDebit', 'paymentCredit', 'account', 'redeemProperty', 'property', 'ftCode', 'onePayCode', 'pRefId', 'note', 'orderType', 'userInfo', 'status', 'refId'];

export default class ReportList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: getTitleTable(ReportListCols, [], []),
            modelItem: ReportListCols,
            componentTable: {
                identity: {
                    key: 'identity',
                    sorter: (i, k) => i.identity - k.identity,
                },
                orderCode: {
                    key: 'orderCode',
                    defaultFilteredValue: this.props.defaultValue.orderCode && [this.props.defaultValue.orderCode],
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    )
                },
                productCode: {
                    key: 'productCode',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    )
                },
                ticketCode: {
                    key: 'ticketCode',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    )
                },
                rateCode: {
                    key: 'rateCode',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    )
                },
                ticketSerial: {
                    key: 'ticketSerial',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    )
                },
                transactionCode: {
                    key: 'transactionCode',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    )
                },
                transactionName: {
                    key: 'transactionName',
                    // filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    //     <HMS.FilterDropdown
                    //         setSelectedKeys={setSelectedKeys}
                    //         selectedKeys={selectedKeys}
                    //         confirm={confirm}
                    //         clearFilters={clearFilters}
                    //     >
                    //     </HMS.FilterDropdown>
                    // ),
                    // filterIcon: filtered => (
                    //     <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    // ),
                    render: (value, record)=>{
                        return CASH_FLOW_REPORT['TRANSACTION_CODE_TYPE'][record.transactionCode || 0]
                    }
                },
                action: {
                    key: 'action',
                    render: (action, data) => CASH_FLOW_REPORT['ACTION_TYPE'][action || 0],
                    filters: Object.entries(CASH_FLOW_REPORT['ACTION_TYPE']).map(item => {
                        return {
                            value: item[0],
                            text: item[1]
                        }
                    }),
                    filterMultiple: false,
                },
                postDate: {
                    sorter: (i, k) => (i.postDate || '').length - k.length,
                    render: (text, record) => record.postDate && moment(moment.utc(record.postDate).toDate()).format(DATE_TIME_FORMAT.DATE_TIME),
                    key: 'postDate',
                },
                orderDebit: {
                    key: 'orderDebit',
                    render: orderDebit => formatMoney(orderDebit)
                },
                paymentCredit: {
                    key: 'paymentCredit',
                    render: paymentCredit => formatMoney(paymentCredit)
                },
                account: {
                    key: 'account',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    )
                },
                ftCode: {
                    key: 'ftCode',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    )
                },
                onePayCode: {
                    key: 'onePayCode',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    )
                },
                refId: {
                    key: 'refId',
                    render: refId => refId > 0 && refId
                }
            },
        };
    }

    render() {
        const { data, loading } = this.props;
        const { cashFlows } = data;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return (
            <Wrapper className={`mt-3`}>
                <HMS.ListComponent 
                    className="cash-flow-report"
                    tableKey="sale-report-list"
                    classParent="m-0 p-0 sale-report-list"
                    marginTop={'0'} marginBottom={'0'}
                    scroll={{ x: 4600 }}
                    loading={{ spinning: loading, size: 'large' }}
                    rowKey={(record, k) => record.createdDate ? record.createdDate.format(DATE_TIME_FORMAT.SHORT_DATE) : k}
                    dataSource={getDataSource(cashFlows || [], modelItem)}
                    columns={columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'cashFlow'
                    })}
                    pagination={{ total: data.totalCount, totalPage: data.totalPage, current: data.pageIndex, pageSize: data.pageSize }}
                    onChange={this.onTableChange}
                    componentTableList={{}}
                />
            </Wrapper>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        return this.props.onTableChange(pagination, filters, sorter)
    }

}